import React from "react";
import Perfil from "./Perfil.jsx";

const ListaPerfiles = (props) => {
    let perfilNodes;
    
    if (props.perfiles && props.perfiles.length > 0) {
        perfilNodes = props.perfiles.map(function (p) {
            return (
                <Perfil id={p.PerfilId}
                    codigo={p.PerfilCodigo}
                    producto={p.ProductoDescripcion} />
            ); 
        });
    }
    else {
        perfilNodes = ( 
            <div className="row" >
                <div className="col-xs-12">
                    <h3>No tiene perfiles asignados</h3>
                </div>
            </div>
        );
    }

    return (
        <div className="row">
            <div className="col-xs-12">
                <h3 className="divisor-section">Perfiles</h3>
            </div>
            <div className="col-xs-12">
                <ul className="list-unstyled">
                    {perfilNodes}
                </ul>
            </div>
        </div>
    );
}

export default ListaPerfiles;